import React from "react";
import { useLeadForm } from "../../hooks/useLeadForm";
import { QuoteFields } from "./QuoteFields";
import { FormStatus } from "./FormStatus";
import { ConsentBlock } from "./ConsentBlock";

export const QuoteForm = ({ t, lang }) => {
  const { form, status, onChange, onSubmit } = useLeadForm(t, lang);
  const loading = status.state === "loading";

  return (
    <div className="bg-white p-6 md:p-10 text-brand-primary">
      <h3 data-testid="form-title" className="font-display font-black text-2xl md:text-3xl tracking-tight">
        {t.contact.formTitle}
      </h3>

      <form onSubmit={onSubmit} data-testid="quote-form" className="mt-6 md:mt-8 space-y-5" noValidate>
        <input
          type="text"
          name="website"
          value={form.website}
          onChange={onChange}
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          data-testid="input-honeypot"
          className="absolute -left-[9999px] h-0 w-0 opacity-0"
        />

        <QuoteFields t={t} form={form} onChange={onChange} />

        <button
          type="submit"
          disabled={loading}
          data-testid="submit-quote-btn"
          className="btn-primary w-full sm:w-auto text-base disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? t.contact.submitting : t.contact.submit}
        </button>

        <ConsentBlock t={t} checked={form.sms_consent} onChange={onChange} />
        <FormStatus status={status} />
      </form>
    </div>
  );
};
